import { render } from "./BrandPichlerVerlag.vue?vue&type=template&id=5ee78efb"
import script from "./BrandPichlerVerlag.vue?vue&type=script&lang=ts"
export * from "./BrandPichlerVerlag.vue?vue&type=script&lang=ts"

import "./BrandPichlerVerlag.vue?vue&type=style&index=0&id=5ee78efb&lang=scss"
script.render = render

export default script